import React, { Component } from 'react';
import CardSimple from 'screens/components/basic/CardSimple';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

class Installation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabs: {
                value: 1
            }
        }
    }

    handleTabs = (value) => {
        this.setState(prevState => ({
            tabs: {
                ...prevState.tabs,
                value: value
            }
        }));
    }

    render() {
        return (
            <div id="printer-installation">
                <br />
                <CardSimple>
                    <div className="support-wrapper-installation support-manual">
                        <h2>Printer Installation</h2>
                        <Tabs value={this.state.tabs.value} onChange={this.handleTabs} className="Menu-tabs-viewpage">
                            <Tab value={1} label="Thermal Printer">
                                <CardSimple>
                                    <div className="support-wrapper support-manual">
                                        <p>Note: Administrator permissions are necessary to do the installation.</p>
                                        <ul>
                                            <li>Extract the .zip file previously downloaded (See the section Devices {`>`} Printers and Scale in this document)</li>
                                            <li>Open Autorun </li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer1.PNG" />
                                            <li>Click on Installation</li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer2.PNG" width="500" />
                                            <li>Read and accept the Installation Agreement</li>
                                            <li>Provide admin credentials(if prompted)</li>
                                            <li>The installation wizard should pop-up now, click on next</li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer3.PNG" width="500" />
                                            <li>Select Typical Installation, click on next</li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer4.PNG" width="500" />
                                            <li>Click on Install to begin with the installation</li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer5.PNG" width="500" />
                                            <li>Wait for the installation completes, when is done click on Finish</li>
                                            <img src="http://techpos.ca/support-images/Installation/printerInstall/printer6.PNG" width="500" />
                                        </ul>
                                    </div>
                                </CardSimple>
                            </Tab>
                            <Tab value={2} label="Zebra Printer">
                                <div>
                                    <CardSimple>
                                        <div className="support-wrapper support-manual">
                                            <p>Note: You need Administrator Permissions for this</p>
                                            <ul>
                                                <li>This installation is for the printer ZDesigner TLP2824 Plus (ZPL) and ZDesigner LP 2824 Plus (ZPL)</li>
                                                <li>Launch the installer previously downloaded (See the section Devices {`>`} Printers and Scale in this document)</li>
                                                <li>Provide administrator permissions to install the driver</li>
                                                <li>Click on next in the Installation Wizard</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer7.PNG" width="500" />
                                                <li>Live the default installation folder, click next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer8.PNG" width="500" />
                                                <li>Click on next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer9.PNG" width="500" />
                                                <li>Read the Important Information in the next screen and click next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer10.PNG" />
                                                <li>Make sure all the check box are marked, click on next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer11.PNG" width="500" />
                                                <li>Wait for the preinstallation of the driver package finishes</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer12.PNG" width="500" />
                                                <li>Click on next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer13.PNG" width="500" />
                                                <li>Click on Install Printer</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer14.PNG" width="500" />
                                                <li>For <b>ZDesigner TLP2824 Plus (ZPL)</b>: Browse to find the model of the printer Click on next</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer15.PNG" width="500" />
                                                <li>Wait for the installation to complete</li>
                                                <img src="http://techpos.ca/support-images/Installation/printerInstall/printer16.PNG" width="500" />
                                                <li>Click on finish once that the installation has finished</li>
                                                <li>For <b>ZDesigner LP 2824 Plus (ZPL)</b>: Browse to find the model of the printer Click on next</li>
                                                <img src="https://techpos.ca/wp-content/uploads/2021/11/printer17.png" width="500" />
                                                <li>Wait for the installation to complete</li>
                                                <img src="https://techpos.ca/wp-content/uploads/2021/11/printer18.png" width="500" />
                                                <li>Click on finish once that the installation has finished</li>
                                            </ul>
                                            {/* <img src={printers1}/> */}
                                        </div>
                                    </CardSimple>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </CardSimple>
                <div id="service-installation">
                    <br />
                    <CardSimple>
                        <div className="support-wrapper support-manual">
                            <h2>Service Installation</h2>
                            <p>NOTE: Make sure you have all the drivers for the printers installed before installing the service<br />
                                This installation works for printer ZDesigner TLP2824 Plus (ZPL) and ZDesigner LP 2824 Plus (ZPL)</p>
                            <ul>
                                <li>Copy the folder TECHPOS Service from the zip drive to your C:\ folder</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-1.png" />
                                <li>After Installing all the drivers successfully, copy all the files from the folder
                                    C:\TECHPOS Service\Dependencies\x64 to C:\Windows\System32</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-2.PNG" />
                                <li>Open Device Manager</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-3.png" />
                                <li>Locate Printer Queues (ZDesigner TLP2824 Plus (ZPL) and ZDesigner LP 2824 Plus (ZPL)) and USB and Serial Ports</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-2-1.PNG" />
                                <li>Take note of the COM Port, Thermal Printer (Star TSP100 Cutter…) and label printer
                                    (ZDesigner TLP 2824 Plus or ZDesigner LP 2824 Plus) as they appear under Printer Queues.</li>
                                <li>Open the file CashRegisterService.exe.config with Notepad</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-4-1.png" />
                                <li>Scroll down and locate the Appsettings Section</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-4.png" />
                                <li>Change the value in the keys : “ThermalPrinter”, “LabelPrinter” and “ScalePort” to match
                                    the ones in device manager (the values you already took note in the previous steps)</li>
                            </ul>
                            <p>NOTE: If you move the printer from the USB port were it was installed to another port, the
                                printer will create a copy of itself and you have to change again the name</p>
                            <ul>
                                <li>Open a Command Prompt as administrator</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-5.png" />
                                <li>Type the following Commands:</li>
                                <ol>
                                    <li>CD\</li>
                                    <li>CD Windows\Microsoft.NET\Framework\v4.0.30319</li>
                                    <li>installutil.exe “C:\TECHPOS Service\CashRegisterService.exe”</li>
                                </ol>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-6.PNG" />
                                <li>Go to Windows Start and type Services</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-7.png" />
                                <br />
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-8.png" />
                                <li>Look for Cash Register Service</li>
                                <li>Right Click on the service and select Properties</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-11.PNG" />
                                <li>On Start Up select Automatic</li>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-10.png" />
                                <li>Click OK</li>
                                <li>Start the Service</li>
                            </ul>
                            <p>NOTE: To uninstall the service follow these steps</p>
                            <ul>
                                <li>Open a Command Prompt as administrator</li>
                                <li>Type the following Commands:</li>
                                <ol>
                                    <li>CD\</li>
                                    <li>CD Windows\Microsoft.NET\Framework\v4.0.30319</li>
                                    <li>installutil.exe -u “C:\TECHPOS Service\CashRegisterService.exe”</li>
                                </ol>
                                <img src="http://techpos.ca/support-images/Installation/serviceInstall/serviceInstall-12.PNG" />
                            </ul>
                        </div>
                    </CardSimple>
                </div>
            </div>

        );
    }
}

export default Installation;